import { type RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw = {
  path: '/admin',
  name: 'Admin',
  children: [
    {
      path: '',
      name: 'Admin | Home',
      component: () => import('./DefaultPage.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'clinics/:id?',
      name: 'Admin | Clinics',
      component: () => import('./clinics/Clinics.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'clinics/setup',
      name: 'Admin | Setup New Clinic',
      component: () => import('./clinics/ClinicsSetup.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'clinics/open-invoices',
      name: 'Admin | Open Invoices',
      component: () => import('./clinics/ClinicsOpenInvoices.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'memos',
      name: 'Admin | Memo',
      component: () => import('./memo/MemoPage.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'colors',
      name: 'Admin | Colors',
      component: () => import('./colors/Colors.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'distributors',
      name: 'Admin | Distributors',
      component: () => import('./distributors/Distributors.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'manufacturers',
      name: 'Admin | Manufacturers',
      component: () => import('./manufacturers/Manufacturers.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'microchip-companies',
      name: 'Admin | Microchip Companies',
      component: () => import('./microchip-companies/MicrochipCompanies.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'reports/microchip-analysis',
      name: 'Admin | Microchip Analysis',
      component: () => import('./reports/MicrochipAnalysis.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'reports/clinic-donations',
      name: 'Admin | Clinic Donations',
      component: () => import('./reports/ClinicDonations.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'reports/clinic-pricing',
      name: 'Admin | Clinic Pricing',
      component: () => import('./reports/ClinicPricing.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'reports/clinic-stats',
      name: 'Admin | Clinic Stats',
      component: () => import('./reports/ClinicStats.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'master-items',
      name: 'Admin | Master Items',
      component: () => import('./master-items/MasterItems.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'species',
      name: 'Admin | Species',
      component: () => import('./species/Species.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'shelterluv',
      name: 'Admin | Shelterluv',
      component: () => import('./translators/shelterluv/ShelterLuv.vue'),
      redirect: '/admin/shelterluv/breeds',
      meta: { active: 'shelterluv', defaultLayout: true },
      children: [
        {
          name: 'Admin | Shelterluv Breeds',
          path: 'breeds',
          component: () => import('./translators/shelterluv/partials/ShelterLuvBreeds.vue'),
          meta: { defaultLayout: true }
        },
        {
          name: 'Admin | Shelterluv Colors',
          path: 'colors',
          component: () => import('./translators/shelterluv/partials/ShelterLuvColors.vue'),
          meta: { defaultLayout: true }
        }
      ]
    },
    {
      path: 'pethealth',
      name: 'Admin | PetHealth',
      component: () => import('./translators/pethealth/PetHealth.vue'),
      redirect: '/admin/pethealth/breeds',
      meta: { active: 'shelterluv', defaultLayout: true },
      children: [
        {
          name: 'Admin | PetHealth Breeds',
          path: 'breeds',
          component: () => import('./translators/pethealth/partials/PetHealthBreeds.vue'),
          meta: { defaultLayout: true }
        },
        {
          name: 'Admin | PetHealth Colors',
          path: 'colors',
          component: () => import('./translators/pethealth/partials/PetHealthColors.vue'),
          meta: { defaultLayout: true }
        }
      ]
    },
    {
      path: 'petlink',
      name: 'Admin | Petlink',
      component: () => import('./translators/petlink/PetLink.vue'),
      redirect: '/admin/petlink/breeds',
      meta: { active: 'petlink', defaultLayout: true },
      children: [
        {
          name: 'Admin | PetLink Breeds',
          path: 'breeds',
          component: () => import('./translators/petlink/partials/PetLinkBreeds.vue'),
          meta: { defaultLayout: true }
        },
        {
          name: 'Admin | PetLink Colors',
          path: 'colors',
          component: () => import('./translators/petlink/partials/PetLinkColors.vue'),
          meta: { defaultLayout: true }
        }
      ]
    },
    {
      path: 'pet-point',
      name: 'Admin | PetPoint',
      component: () => import('./translators/pet-point/PetPoint.vue'),
      redirect: '/admin/pet-point/breeds',
      meta: { active: 'pet-point', defaultLayout: true },
      children: [
        {
          name: 'Admin | PetPoint Breeds',
          path: 'breeds',
          component: () => import('./translators/pet-point/partials/PetPointBreeds.vue'),
          meta: { defaultLayout: true }
        }
      ]
    },
    {
      path: 'drugs',
      name: 'Admin | Drugs',
      component: () => import('./drugs/Drugs.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'leads',
      name: 'Admin | Leads',
      component: () => import('./leads/Leads.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'organizations',
      name: 'Admin | Clinic Organizations',
      component: () => import('./organizations/Organizations.vue'),
      meta: { defaultLayout: true }
    },
    {
      path: 'organizations/a2p',
      name: 'Admin | A2P Registrations',
      component: () => import('./organizations/OrganizationsA2p.vue'),
      meta: { defaultLayout: true }
    }
  ]
}
